module.exports = "/dist/src/img/anim/loader.gif";